<template>
	<div class="container">
		<div class="content">
			<div v-show="mode === 'list'" class="card">
				<h3 class="title mb_16">
					{{ $t('rtr_activity-c2c.title1') }}
				</h3>
				<!-- 탭메뉴 -->
				<div class="d_flex flex_column mb_16" v-if="canFilter">
					<!-- 시작,종료 날짜데이터 -->
					<div class="d_flex">
						<div class="info mr_10">
							<date-picker
								is-required
								v-model="startDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
											:disabled="!canFilter"
										/>
									</label>
								</template>
							</date-picker>
						</div>
						<div class="info">
							<date-picker
								is-required
								v-model="endDate"
								:model-config="{ type: 'string' }"
								:locale="$store.state.common.locale"
							>
								<template v-slot="{ inputValue, inputEvents }">
									<label class="calendar_area">
										<input
											class="px-2 py-1 border rounded focus:outline-none focus:border-blue-300"
											:value="inputValue"
											v-on="inputEvents"
											:disabled="!canFilter"
										/>
									</label>
								</template>
							</date-picker>
						</div>
					</div>
					<!-- 암호자산 선택 -->
					<div
						class="select_area w100 mt_8"
						v-show="selectedTab === 2 && canFilter"
					>
						<select v-model="assetSeq" class="asset_area">
							<option :value="null">
								{{ $t('input.placeholder.all_assets') }}
							</option>
							<option
								v-for="item in accounts"
								:key="item.seq"
								:value="item.asset_seq"
							>
								{{ item.asset_title }}
							</option>
						</select>
						<span class="select_icon"></span>
					</div>
				</div>
				<ul class="tab_area mb_8">
					<li
						:class="[{ selected: selectedTab === 1 }, 'buy']"
						@click="selectedTab = 1"
					>
						<a>{{ $t('rtr_activity-c2c.tab1') }}</a>
					</li>
					<li
						:class="[{ selected: selectedTab === 2 }, 'sell']"
						@click="selectedTab = 2"
					>
						<a>{{ $t('rtr_activity-c2c.tab2') }}</a>
					</li>
				</ul>

				<!-- 테이블 시작 -->
				<div v-if="selectedTab === 1">
					<Purchase
						@showDetail="showApplicationDetail"
						:start-date="startDate"
						:end-date="endDate"
					></Purchase>
				</div>
				<div v-if="selectedTab === 2">
					<div v-show="dealMode === 'list'">
						<SaleM
							@showDetailList="showDealDetailList"
							:start-date="startDate"
							:end-date="endDate"
							:asset-seq="assetSeq"
						></SaleM>
					</div>
					<div v-if="dealMode === 'dealDetailList'">
						<SaleDetailList
							@showDealList="dealMode = 'list'"
							@showDetail="showApplicationDetail"
							:deal-seq="dealSeq"
						></SaleDetailList>
					</div>
				</div>
			</div>
			<div v-if="mode === 'applicationDetail'" class="card">
				<PurchaseDetail
					:init-info="applicationInfo"
					@showList="mode = 'list'"
				></PurchaseDetail>
			</div>
			<div v-if="mode === 'dealDetail'" class="card">
				<SaleDetail
					:init-info="applicationInfo"
					@showList="mode = 'list'"
				></SaleDetail>
			</div>
		</div>
	</div>
</template>

<script>
import Purchase from '@/components/User/Activity/Purchase.m.vue';
import PurchaseDetail from '@/components/User/Activity/PurchaseDetail.m.vue';
import SaleM from '@/components/User/Activity/Sale.m.vue';
import SaleDetailList from '@/components/User/Activity/SaleDetailList.m';
import SaleDetail from '@/components/User/Activity/SaleDetail.m';
import { mapGetters } from 'vuex';
import '@/assets/css/activity.m.css';

export default {
	name: 'C2c.m',
	components: {
		Purchase,
		PurchaseDetail,
		SaleM,
		SaleDetailList,
		SaleDetail,
	},
	data() {
		return {
			selectedTab: 1,
			assetSeq: null,
			startDate: this.$dayjs(new Date()).add(-1, 'month').toDate(),
			endDate: new Date(),
			mode: 'list',
			dealMode: 'list',
			applicationInfo: {},
			dealSeq: null,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		canFilter() {
			return this.mode === 'list' && this.dealMode === 'list';
		},
	},
	watch: {
		selectedTab() {
			this.assetSeq = null;
			this.dealMode = 'list';
		},
		mode() {
			window.scrollTo(0, 0);
		},
		dealMode() {
			window.scrollTo(0, 0);
		},
	},
	methods: {
		showApplicationDetail(applicationInfo) {
			this.applicationInfo = applicationInfo;
			if (this.selectedTab === 1) {
				this.mode = 'applicationDetail';
			} else if (this.selectedTab) {
				this.mode = 'dealDetail';
			}
		},
		showDealDetailList(dealSeq) {
			this.dealSeq = dealSeq;
			this.dealMode = 'dealDetailList';
		},
	},
};
</script>
<style scoped></style>
